import { bootstrap, IClientSDK } from '@sxm-web/client-sdk-core';
import { getDeviceInfo } from './device-info/get-device-info';
import { SentryConfig } from './observability/types-sentry';
import { IStorageProvider } from './storage-provider/types';
import * as baseConfig from './config/config.json';
import { updateConfigBaseUrl } from './config/update-config-base-url';
import { getLocalStorageProvider } from './storage-provider/get-local-storage-provider';

const { config } = baseConfig;

export async function bootstrapClientSdk({
    baseUrl,
    clientSdkStorageProvider,
}: {
    baseUrl: string;
    sentry: SentryConfig;
    clientSdkStorageProvider: IStorageProvider;
}): Promise<Partial<IClientSDK>> {
    updateConfigBaseUrl({ config, baseUrl: baseUrl });
    const clientSdk = await bootstrap(
        config as any,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        () => {},
        clientSdkStorageProvider,
        getLocalStorageProvider(),
        getDeviceInfo(),
    );

    return clientSdk;
}
